import { PagedFilterAndSortedRequest } from 'services/dto';
import { Concern, TenantConcern } from './concern';

export interface ConcernCategory {
  id: string;
  name: string;
  description: string;
  concerns: Concern[];
  creationTime: string;
}

export interface TenantConcernCategory {
  id: string;
  name: string;
  description: string;
  concerns: TenantConcern[];
}

export interface CreateConcernCategory {
  id?: string;
  name: string;
  description: string;
  concerns: Concern[];
}

export interface PagedConcernCategoryRequestDto extends PagedFilterAndSortedRequest {
  name: string;
}

export interface PagedTenantConcernsRequestDto extends PagedFilterAndSortedRequest {
  concernId?: string | undefined;
  userId?: number | undefined;
  name?: string | undefined;
  categoryName?: string | undefined;
  serviceName?: string | undefined;
  isActivated?: boolean | undefined;
}

export const InitialCreateConcernCategory: CreateConcernCategory = {
  name: '',
  description: '',
  concerns: [],
};
